module.exports = __webpack_public_path__ + "static/vic-ce88211ec55b632b2ce42385f2498715.jpg";